import { mapListToRecords } from '@sophocles/entities/entityUtils';
import { IntrusionSensorConfiguration } from '@sophocles/entities/IntrusionSensorConfiguration/intrusionSensorConfigurationRecord';

/* Receive Actions */
export const RECEIVE_INTRUSION_SENSOR_CONFIGURATIONS = 'RECEIVE_INTRUSION_SENSOR_CONFIGURATIONS';
export function receiveIntrusionSensorConfigurations(json) {
  return {
    type: RECEIVE_INTRUSION_SENSOR_CONFIGURATIONS,
    intrusionSensorConfigurations: mapListToRecords(json, IntrusionSensorConfiguration),
  };
}

/* Delete Actions */
export const DELETE_INTRUSION_SENSOR_CONFIGURATION = 'DELETE_INTRUSION_SENSOR_CONFIGURATION';
export function sayDeleteIntrusionSensorConfiguration(intrusionSensorConfiguration_id) {
  return {
    type: DELETE_INTRUSION_SENSOR_CONFIGURATION,
    intrusionSensorConfiguration: intrusionSensorConfiguration_id,
  };
}
